/**
 * The MR monogram assets — kept in one place so the static head tag, the
 * runtime tab-icon manager, the venue install icons and the venue headers all
 * point at the same files.
 *
 * The browser tab icon is the vector monogram, which stays sharp at any size.
 * The home-screen and venue header slots use the square raster plate instead:
 * iOS and Android both mask a home-screen icon themselves, so those files are
 * deliberately full-bleed squares with no rounding of our own.
 */

/** Browser tab icon on every screen. Not used for the home screen or headers. */
export const MR_MONOGRAM_URL =
  'https://base44.app/api/apps/69e7659143303e8153678f84/files/mp/public/69e7659143303e8153678f84/41f01d079_MR_icon_red_white_curved.svg';

/** Venue home-screen icons — square-bleed, masked by the device itself. */
export const VENUE_TOUCH_ICON_180_URL =
  'https://media.base44.com/images/public/69e7659143303e8153678f84/7b648665c_square-apple-touch-icon-180.png';

export const VENUE_ICON_192_URL =
  'https://media.base44.com/images/public/69e7659143303e8153678f84/11bdac1ba_square-icon-192.png';

export const VENUE_ICON_512_URL =
  'https://media.base44.com/images/public/69e7659143303e8153678f84/a23a2d9e8_square-icon-512.png';

/**
 * The venue mark shown in the venue headers — the same square plate art as the
 * install icons, so the header and the home-screen icon can never drift apart.
 */
export const MR_SQUARE_MARK_URL = VENUE_ICON_512_URL;